// @ts-strict-ignore
export interface EHRInfo {
  integrationType: string;
  ehrName: string;
}

let ehrInfoState: EHRInfo = null;

export const getEHRInfoState: () => EHRInfo = () => ehrInfoState;
export const resetEHRInfoState = () => {
  ehrInfoState = null;
};
export const updateEHRInfoState = (newVal: EHRInfo) => {
  ehrInfoState = newVal;
};
